<template>
    <b-modal v-model="show" title="ҲУДУДИЙ ЗОНА ПАРАМЕТР" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>{{$t("realEstate.field.province")}} <span class="red">*</span></label>
                        <v-select label="label"
                                v-model="dictionaryData.data.province"
                                :filterable="false"
                                :options="provinces"
                                @change="onChangeProvince"
                        >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                        <div class="red" v-if="$v.dictionaryData.data.province.id.$error">
                            {{$t("realEstate.validation.province")}}
                        </div>
                    </div>
                    <div class="form-group">
                        <label>{{$t("realEstate.field.region")}} <span class="red">*</span></label>
                        <v-select label="label"
                                :options="regions"
                                v-model="dictionaryData.data.region"
                                :filterable="false"
                                @search="onRegionSearch"
                                @search:focus="onRegionFocus"
                        >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                        <div class="red" v-if="$v.dictionaryData.data.region.id.$error">
                            {{$t("realEstate.validation.region")}}
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label>Зона ва коэффициент</label>
                        <div class="table-responsive">
                            <div class="table-wrapper">
                              <table class="table table-striped" style="min-width: 400px">
                                  <thead>
                                  <tr>
                                      <th>Зона</th>
                                      <th>Коэффициент</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <template v-if="dictionaryData.data.childFields && dictionaryData.data.childFields.length > 0">
                                      <tr v-for="(field,index) in dictionaryData.data.childFields" :key="field.id">
                                          <td class="text-center">
                                              <span>{{field.zone}}</span>
                                          </td>
                                          <td>
                                              <numeric-input class="form-control"
                                                             :precision="2" align="right"
                                                             v-model="field.value"
                                                             :class="{invalid : $v.dictionaryData.data.childFields.$each[index].value.$error}"
                                              />
                                          </td>
                                      </tr>
                                  </template>
                                  <tr>
                                      <td></td>
                                      <td class="text-right">
                                          <button class="all-btn add-btn icon-btn" @click="addField">+</button>
                                      </td>
                                  </tr>
                                  </tbody>
                              </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="close">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {clone} from '@/shared/utils';
    import {required,minValue} from 'vuelidate/lib/validators';
    import initFilterModel from '@/shared/filter';

    export default {
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                filterProvince: initFilterModel(),
                filterRegion: initFilterModel(),
                dictionaryData: this.initData(),
                provinces: [],
                region: {},
                province: {},
                regions: [],
                lastFieldId: 4
            }
        },
        validations() {
            return {
                dictionaryData: {
                    data: {
                        province: {
                            id: {
                                required
                            }
                        },
                        region: {
                            id: {
                                required
                            }
                        },
                        childFields: {
                            $each: {
                                value: {
                                    required,
                                    minValue: minValue(0.01)
                                }
                            }
                        }
                    }
                }
            }
        },
        methods: {
            initData() {
                return {
                    id: null,
                    dictionaryType: 'COEFFICIENT_OF_TERRITORIAL_ZONES',
                    data: {
                        province: null,
                        region: null,
                        childFields: [
                            {
                                zone: 1,
                                value: 0
                            },
                            {
                                zone: 2,
                                value: 0
                            }
                        ]
                    }
                }
            },
            init() {
                const vm = this;
                vm.provinces = [];
                vm.filterProvince.search = '';
                this.$http.post('/province/list', vm.filterProvince)
                    .then(res => {
                        vm.provinces = this.getAsMaps(res.data);
                    }, err => {
                        console.log(err);
                    });
            },
            getAsMaps(result) {
                if (result && result.data && result.data.length > 0) {
                    return result.data.map(d =>({id: d.id, label: d.name}))
                }
                return [];
            },
            save() {

                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;
                this.processing = true;
                this.$http.post('dictionary/save', this.dictionaryData)
                    .then(res => {
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$emit('change')
                        }
                        vm.processing = false;
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
            },
            addField() {
                this.lastFieldId += 1;
                this.dictionaryData.data.childFields.push({
                    zone: this.lastFieldId,
                    value: 0
                });
            },
            close() {
                this.show = false;
            },
            onChangeProvince() {
                this.dictionaryData.data.region = null
            },
            onRegionSearch(searchTxt, loading) {
                loading(true);
                this.regions = [];
                this.filterRegion.search = searchTxt;
                this.filterRegion.provinceId = (this.dictionaryData.data.province && this.dictionaryData.data.province.id) ? this.dictionaryData.data.province.id : 0;
                this.$http.post('/region/search', this.filterRegion)
                    .then(res => {
                        this.regions = this.getAsMaps(res.data);
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionFocus() {
                this.regions = [];
                this.filterRegion.provinceId = (this.dictionaryData.data.province && this.dictionaryData.data.province.id) ? this.dictionaryData.data.province.id : 0;
                this.$http.post('/region/search', this.filterRegion)
                    .then(res => {
                        this.regions = this.getAsMaps(res.data);
                    }, err => {
                        console.log(err);
                    });
            }
        },
        created() {
            this.filterProvince.page.size = 1000;
            this.filterRegion.page.size = 1000;
            this.init();
            this.$eventBus.$on("showCoefficientOfTerritorialZonesModal", (data) => {
                if (data) {
                    this.dictionaryData = clone(data);
                } else {
                    this.lastFieldId = 2;
                    this.dictionaryData = this.initData();
                }
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>